export default __webpack_public_path__ + "static/media/room-polen-2.6af63680.webp";